export default "/assets/images/sock.png?3f830e43ddb2275c4e4c10f23cd4ae50";